import { PersonalDetailsSchema } from './PersonalDetails.styles';

export const personalDetailsStyles: PersonalDetailsSchema = {
  wrapperBox: {
    sx: {
      '&&': {
        '.chakra-input': {
          border: 'none',
          borderLeftRadius: 'md',
          bg: 'beta.900',
          color: 'whiteAlpha.700',
          fontSize: 'xs',
          fontWeight: 'normal',
          _hover: {
            border: 'none',
          },
        },
        '.chakra-form__label': {
          fontSize: 'xs',
        },
      },
    },
  },
};
